import React from 'react';
import ReactDOM from 'react-dom';
// import 'antd/dist/antd.css';
// import './index.css';
import { Upload, Icon, Modal } from 'antd';

import { API_ENDPOINT } from '../../index'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class Uploader extends React.Component {
  constructor(props) {
    super(props)

    let {imageUrl} = this.props

    // to account for old model of imageUrl = String
    if (imageUrl && imageUrl.length>0 && Object.keys(imageUrl).length > 5) {
      imageUrl = [{
        uid: '-1',
        name: 'image.png',
        status: 'done',
        url: Object.values(imageUrl).join('') 
      }] 
    }

    this.state = {
      previewVisible: false,
      previewImage: '',
      fileList: imageUrl
    }
  }
  
  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };

  handleChange = ({ fileList }) => {
    this.setState({ fileList });
    this.props.handleChange({fileList})
  }

  render() {
    const { previewVisible, previewImage } = this.state;
    let { fileList } = this.state;

    const { readOnly, maxNumOfImages } = this.props;

    fileList = fileList || []

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <div className="clearfix">
        <Upload
          action={`${API_ENDPOINT}/api/upload/bug-screenshot`}
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          showUploadList={{
            showPreviewIcon: true, 
            showDownloadIcon: false, 
            showRemoveIcon: true && !readOnly }}

          name='picture'
          accept="image/*"
          withCredentials={true}
        >
          {fileList.length >= maxNumOfImages || readOnly ? null : uploadButton}
        </Upload>

        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel} width='65vw'>
          <img alt="image" style={{ width: '100%' }} src={previewImage} />
        </Modal>

      </div>
    );
  }
}

export default Uploader;
          


// WEBPACK FOOTER //
// ./src/components/bug-report/uploader.js